import intersect from './intersect';

const setStickyContainerTop = (localNavElement: HTMLElement, stickyContainer: HTMLElement) => {
  const isMobileView = window.innerWidth < 768;
  const localNavElementHeight = localNavElement.getBoundingClientRect().height;
  stickyContainer.style.top = isMobileView ? `${localNavElementHeight}px` : '0';
  stickyContainer.style.position = isMobileView ? `sticky` : 'relative';
};

const updateStickyContainerTop = (localNavElement: HTMLElement, stickyContainer: HTMLElement) => {
  setStickyContainerTop(localNavElement, stickyContainer);

  const intersector = intersect('.ftbl__competition-board__sticky-container');
  intersector((entry: HTMLElement) => {
    setStickyContainerTop(localNavElement, entry);
  });
};

export const competitionBoardStickyContainer = () => {
  const localNavElement = document.querySelector<HTMLElement>('.j-local-nav');
  const stickyContainer = document.querySelector<HTMLElement>('.ftbl__competition-board__sticky-container');

  if (!stickyContainer || !localNavElement) {
    console.info('🚫 COMPETITION BOARD STICKY disabled');
    return;
  }

  console.info('✅ COMPETITION BOARD STICKY enabled');

  window.addEventListener('load', () => updateStickyContainerTop(localNavElement, stickyContainer));
  window.addEventListener('resize', () => updateStickyContainerTop(localNavElement, stickyContainer));

  const observer = new MutationObserver(() => updateStickyContainerTop(localNavElement, stickyContainer));
  observer.observe(document.body, { childList: true, subtree: true });

  updateStickyContainerTop(localNavElement, stickyContainer);
};
